import Command from "@ckeditor/ckeditor5-core/src/command";

export default class CitationsCitedRefsReorderCommand extends Command {
  execute({ value }) {
    const editor = this.editor;
    const range = editor.model.createRangeIn(editor.model.document.getRoot());
    const refsToBeReOrdered = [];
    const firstCitedRef = [];
    for (const data of value.data) {
      for (const item of range.getItems({ ignoreElementEnd: true })) {
        if (item.getAttribute("id") === data.id) {
          firstCitedRef.push(item);
        }

        if (item.getAttribute("data-parentcitation") === data.id) {
          refsToBeReOrdered.push(item)
        }
      }

      editor.model.change((writer) => {
        if (firstCitedRef.length === 0) {
          for (let i = 0; i < refsToBeReOrdered.length; i++) {
            if (i == 0) {
              writer.removeAttribute(
                "data-parentcitation",
                refsToBeReOrdered[i]
              );
            } else {
              writer.setAttribute(
                "data-parentcitation",
                refsToBeReOrdered[0].getAttribute("id"),
                refsToBeReOrdered[i]
              );
            }
          }
        }
      });
      refsToBeReOrdered.length = 0;
    }
  }
}
